<div class="w-100">
    <app-loader *ngIf="showLoader"></app-loader>
     <div class="header" *ngIf="dialogData?.isOpenedFromDashboard">
        <div class="d-flex w-100 py-3 px-4">
          <div class="me-2 id flex-fill">
            <h4 class="modal-title mb-0 item-id">
              Proposals - {{ dialogData?.filteredStatus }}
            </h4>
          </div>

          <div class="btns-header">
            <button class="close" (click)="dialogRef.close()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <!-- <button class="close expand-modal" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" style="font-weight: bold;" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
              [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button> -->
          </div>
        </div>
    </div>
        <!-- <a href="javascript:;" (click)="openLeaseRateCalculator()"> Lease Rate Calculator</a> -->

    <ejs-grid *ngIf="showGrid"
        #proposalGrid
        [id]="gridName"
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 20 }"
        [gridLines]="false"
        [allowFiltering]="true"
        [query]="query"
        [showColumnChooser]="true"
        [height]="gridHeight"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [allowExcelExport]="true"
        [enablePersistence]="true"
        [allowSelection]="true"
        [sortSettings]="sortOptions"
        [searchSettings]="searchSettings"
        [editSettings]="{ allowEditing: false }"
        [filterSettings]="{ type: 'Menu' }"
        (toolbarClick)="onToolbarClick($event)"
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="commandClick($event, proposalGrid)"
        (created)="created()"
        (actionComplete)="onGridActionComplete($event, proposalGrid)"
        (dataBound)="dataBound($event)"
        >
        <e-columns>
            <e-column
                *ngFor="let column of columns;"
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting ?? true"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                <ng-template *ngIf="column.field === 'statusText'" #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
                </ng-template>
                <ng-template *ngIf="column.field === 'proposalId'" #template let-data>
                  <i class="fas" [ngClass]="{ 'fa-circle-check color-green': data.isActive, 'fa-ban color-red': !data.isActive }" [title]="data.isActive ? 'Active': 'Inactive'"></i>
                  <a href="javascript:" (click)="openProposalPopup(null, null, data.proposalId)">
                    {{ data.proposalId }}
                  </a>
                </ng-template>
                <!-- <ng-template *ngIf="column.field === 'customer'" #template let-data>
                  {{data?.customerId +" - "+ data.customer}}
                </ng-template> -->
                <ng-template *ngIf="column.field === 'customer'" #template let-data>
                  <a href="javascript:" (click)="openProspectPopup(data.customerId)">
                    {{ data.customer }}
                  </a>
                </ng-template>
                <ng-template *ngIf="column.field === 'salesLeadId'" #template let-data>
                  <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
                </ng-template>
                <ng-template *ngIf="column.field === 'opportunityId'" #template let-data>
                  <a href="javascript:" (click)="openOpportunityPopup(data.opportunityId)">{{data.opportunityId}}</a>
                </ng-template>
                <ng-template *ngIf="column.field === 'accountName'" #template let-data>
                  <a *ngIf="data.accountName" href="javascript:" (click)="openDistributorPopup(data)">{{data.accountName}}</a>
                </ng-template>
            </e-column>
        </e-columns>
    </ejs-grid>
  </div>

  <ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
    ></app-column-chooser>
  </ng-template>

  <ng-template #addLeads>
    <i *ngIf="rolePermissions['proposalGrid_add']?.visible" class="fas fa-add"></i>
  </ng-template>

  <app-proscpects-popup
  *ngIf="showProspectsPopup"
    [prospectData]="prospectData"
    [tab]="'details'"
    (onClose)="showProspectsPopup = false"
    >
  </app-proscpects-popup>
